export default {
  namespaced: true,
  state: () => ({
    queryData: {},
  }),
  mutations: {
    setQueryData(state, payload) {
      state.queryData = payload
      if (payload.token) {
        localStorage.setItem("token", payload.token);
      }
    },
  }

}
